import { useWebsiteLogo } from '../hooks/useWebsiteLogo';

const WebsiteLogo = ({ token, className = '', alt = 'Logo' }) => {
    const { logoUrl } = useWebsiteLogo(token);

    return (
        <img
            src={logoUrl}
            alt={alt}
            className={className}
        />
    );
};

export default WebsiteLogo;
